import { getNested } from "@/utils/utils";

export const namespaced = true;
export const state = {
  errors: [],
};
export const mutations = {
  resetErrorState(state) {
    state.errors = [];
  },
  addError(state, err) {
    //err = { str(type), str(slot_number), str(port) }
    // console.log("add error", err);
    //dont add it if is already in lst
    let idx = state.errors.findIndex(
      (el) =>
        el.slot == err.slot &&
        (err.port ? el.port == err.port : true) &&
        (err.type ? el.type.indexOf(err.type) > -1 : true)
    );
    // console.log("idxr", idx);
    if (idx == -1) {
      state.errors.push(err);
    }
  },
  deleteError(state, err) {
    //err={str(slot),str(port), str(type)}  port,type optional
    // console.log("rem error", err);
    let errors = state.errors;
    let idx = state.errors.findIndex(
      (el) =>
        el.slot == err.slot &&
        el.port == err.port &&
        el.type.indexOf(err.type) > -1
    );
    if (idx > -1) {
      errors.splice(idx, 1);
    }
  },
};
export const getters = {
  slotError(state) {
    return (slot) => {
      //slot=string
      return state.errors.filter((el) => el.slot === slot);
    };
  },
};
export const actions = {
  license_check({ commit, rootState }, slot) {
    const slotn = isNaN(slot) ? slot : "slot" + slot;

    const cModule = getNested(rootState.frame.modules, slotn);

    const sfps =
      typeof cModule.sfpPorts != "undefined"
        ? Object.keys(cModule.sfpPorts)
        : [];
    // check for subModule sfps
    if (getNested(cModule, "modules")) {
      for (const subSlot in cModule.modules) {
        if (Object.hasOwn(cModule.modules, subSlot)) {
          const subModule = cModule.modules[subSlot];
          if (subModule.type && subModule.type == "MODXSFP") {
            if (subModule.sfpPorts) {
              for (const port in subModule.sfpPorts) {
                if (Object.hasOwn(subModule.sfpPorts, port)) {
                  sfps.push(`${subSlot}.${port}`);
                }
              }
            }
          }
        }
      }
    }

    for (let x = 0; x < sfps.length; x++) {
      //is license assigned to SFP slot?
      let cPort;
      if (sfps[x].includes(".")) {
        const pAddr = sfps[x].split(".");
        cPort = getNested(cModule.modules, pAddr[0], "sfpPorts", pAddr[1]);
      } else {
        cPort = getNested(cModule.sfpPorts, sfps[x]);
      }
      if (!cPort) {
        continue;
      }

      const slotLicense = this.getters.getSlotLicenses(slotn);
      const skipLicenseCheck = [
        "ultrisync",
        "ultrisyncuhd",
        "ultrisrc",
        "ultriprocHDR",
        "ultriproc3D",
      ];
      for (const key in slotLicense) {
        if (skipLicenseCheck.includes(key)) {
          continue;
        } else {
          if (Object.hasOwn(slotLicense, key)) {
            const element = slotLicense[key];
            if (element.indexOf(sfps[x]) > -1) {
              //is there SFP fitted?

              if (typeof cPort.type != "undefined") {
                //does fitted SFP satisfy license
                let licReq = Object.keys(cPort.licenseApplicable);
                if (licReq.indexOf(key) > -1) {
                  //statisfied
                  commit("deleteError", {
                    type: key,
                    slot: slotn,
                    port: sfps[x],
                  });
                }
              } else {
                commit("addError", {
                  type: key,
                  slot: slotn,
                  port: sfps[x],
                  reason: "No SFP fitted",
                });
              }
            } else {
              commit("deleteError", {
                type: key,
                slot: slotn,
                port: sfps[x],
              });
            }
          }
        }
      }
    }

    let UscapeCount = cModule?.ultriscapeLicenses
      ? cModule.ultriscapeLicenses
      : [];

    const uStream = getNested(
      cModule,
      "licenses",
      "ultristreamOut",
      "positions",
      "length"
    );
    if (uStream || uStream > 0) {
      if (UscapeCount.length > 0) {
        //got both ustream and no  uscape so delete any errors
        commit("deleteError", {
          slot: slotn,
          port: "Ultristream",
          type: "Ultriscape",
          reason: "No Ultriscape assigned",
        });
      } else {
        commit("addError", {
          slot: slotn,
          port: "Ultristream",
          type: "Ultriscape",
          reason: "No Ultriscape assigned",
        });
      }
    }
  },
};
